import styled from 'styled-components';
import { color } from '@lendi-ui/color';

function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}

var isHex = str => str.match(/^#(?:[0-9a-fA-F]{3}){1,2}$/);
var getColorStr = function getColorStr(color$1) {
  // If we have a hex code
  if (isHex(color$1)) return color$1;
  return color(color$1);
};
var IconWrapper = styled.span.withConfig({
  displayName: "Icon__IconWrapper",
  componentId: "lui__sc-1jznn6y-0"
})(["width:", ";height:", ";vertical-align:middle;display:inline-block;& > svg{fill:", ";width:inherit;height:inherit;}[class$='fillPath']{fill:", ";}"], _ref => {
  var {
    width
  } = _ref;
  return width !== null && width !== void 0 ? width : '1em';
}, _ref2 => {
  var {
    height
  } = _ref2;
  return height !== null && height !== void 0 ? height : '1em';
}, _ref3 => {
  var {
    color
  } = _ref3;
  return color ? getColorStr(color) : 'currentColor';
}, _ref4 => {
  var {
    color
  } = _ref4;
  return color ? getColorStr(color) : 'currentColor';
});

export { IconWrapper as I, _objectSpread2 as _ };
